module.exports = {
      id: "location-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#location-usage",
      toString: function () {
        return this.url;
      }
    }